import React from "react";
import { Container } from "react-bootstrap";
import "./AppFooter.css";

export default function AppFooter({
    brand = "AbhisaraNa (अभिसरण)",
    version = "v0.79.21",
    main_disclaimer_msg = "The information displayed in this application is for informational purposes only and should not be considered financial, legal, or investment advice.",
    copyright = `© ${new Date().getFullYear()} AbhisaraNa Systems. All rights reserved.`,
    disclaimer_info="More about Risks in Mutual Fund - https://www.amfiindia.com/investor/knowledge-center-info?zoneName=riskInMutualFunds."
}) {
    return (
        <footer className="app-footer mt-md-5">
            <Container fluid>
                <hr className="footer-divider" />
                <div className="footer-disclaimer-msg">
                    {main_disclaimer_msg}
                </div>
                <div className="footer-disclaimer-info">
                    {disclaimer_info}
                </div>
                <div className="footer-branding">
                    <div className="brand-name">{brand}</div>
                    <div className="footer-copyright">
                        {copyright}
                    </div>
                    <div className="brand-version">{version}</div>
                </div>
            </Container>
        </footer>
    );
}